var _defs, _g, _text;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAriselogo011(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 1080 1080",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\r\n      .st0 {\r\n        fill: #fbc1a6;\r\n      }\r\n\r\n      .st1 {\r\n        fill: #f36f44;\r\n      }\r\n\r\n      .st2 {\r\n        fill: #010101;\r\n      }\r\n\r\n      .st3 {\r\n        fill: #f8a582;\r\n      }\r\n\r\n      .st4 {\r\n        fill: #fddece;\r\n      }\r\n\r\n      .st5 {\r\n        fill: #fff;\r\n      }\r\n\r\n      .st6 {\r\n        fill: #f04f2a;\r\n      }\r\n\r\n      .st7 {\r\n        fill: #f68a63;\r\n      }\r\n\r\n      .st8 {\r\n        fill: #231f20;\r\n        font-family: HCLTechRoobert-ExtraBold, 'HCLTech Roobert';\r\n        font-size: 55.59px;\r\n        font-weight: 700;\r\n      }\r\n    "))), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M300.14,557.56c-5.22-9.36-7.83-22.74-7.83-40.14,0-14.25,1.86-25.19,5.59-32.81,3.73-7.62,8.91-13.21,15.54-16.78,6.63-3.56,16.74-7.5,30.32-11.81l11.93-3.98v-18.64c0-4.8-.96-8.49-2.86-11.06-1.91-2.57-4.19-3.85-6.84-3.85-2.32,0-4.35,1.08-6.09,3.23-1.74,2.16-2.61,5.06-2.61,8.7v10.94h-42.26v-5.97c0-17.9,4.18-30.66,12.55-38.28,8.37-7.62,22-11.43,40.89-11.43,15.08,0,27.34,3.94,36.79,11.81,9.45,7.87,14.17,19.02,14.17,33.43v138.7h-43.25v-21.62c-2.16,7.46-5.59,13.26-10.32,17.4-4.72,4.14-10.32,6.21-16.78,6.21-14.09,0-23.74-4.68-28.96-14.04ZM353.33,533.7c1.41-2.73,2.11-6.09,2.11-10.07v-50.71c-6.46,2.49-11.23,5.64-14.29,9.45-3.07,3.81-4.6,9.12-4.6,15.91v23.36c0,10.77,3.23,16.16,9.69,16.16,3.31,0,5.67-1.37,7.08-4.1Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M416.09,387.66h43.5v20.13c2.15-7.12,5.92-12.63,11.31-16.53,5.38-3.89,12.06-5.84,20.01-5.84v36.29c-6.13,0-12.89.87-20.26,2.61-7.38,1.74-11.06,3.77-11.06,6.09v139.2h-43.5v-181.95Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M558.02,516.92l.25-14.42h43.5l.25,21.38c0,4.31.83,7.58,2.49,9.82,1.65,2.24,4.39,3.36,8.2,3.36,5.8,0,8.7-4.72,8.7-14.17,0-6.96-1.37-12.43-4.1-16.41-2.73-3.98-7.08-8.2-13.05-12.68l-23.12-17.9c-7.95-6.13-13.67-12.47-17.15-19.02-3.48-6.54-5.22-15.78-5.22-27.71,0-9.28,2.44-17.19,7.33-23.74,4.88-6.54,11.39-11.47,19.51-14.79,8.12-3.31,17.15-4.97,27.09-4.97,35.3,0,52.94,17.57,52.94,52.7v3.48h-44.99v-6.96c0-4.31-.71-7.99-2.11-11.06-1.41-3.06-3.77-4.6-7.08-4.6-2.98,0-5.26.87-6.84,2.61-1.58,1.74-2.36,4.1-2.36,7.08,0,6.63,2.57,11.77,7.71,15.41l26.85,19.64c9.61,7.13,16.98,14.88,22.12,23.24,5.13,8.37,7.71,18.93,7.71,31.69,0,16.9-4.81,29.91-14.42,39.02-9.61,9.12-23.04,13.67-40.27,13.67-35.96,0-53.94-18.23-53.94-54.68Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M690.75,556.19c-8.12-10.27-12.18-25.6-12.18-45.98v-73.08c0-16.74,4.8-29.49,14.42-38.28,9.61-8.78,23.03-13.17,40.27-13.17,34.96,0,52.45,17.15,52.45,51.45v13.17c0,13.26-.17,24.03-.5,32.31h-63.13v35.3c0,6.3.66,11.23,1.99,14.79,1.32,3.57,4.14,5.34,8.45,5.34,3.31,0,5.67-1,7.08-2.98,1.41-1.99,2.24-4.26,2.49-6.83.25-2.57.37-6.34.37-11.31v-17.65h43.25v10.44c0,21.21-4.1,36.83-12.3,46.85-8.2,10.03-22.33,15.04-42.38,15.04-18.73,0-32.15-5.13-40.27-15.41ZM742.45,460.99v-23.37c0-13.09-3.23-19.64-9.69-19.64-7.29,0-10.94,6.55-10.94,19.64v23.37h20.63Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    className: "st2",
    x: 501.35,
    y: 387.66,
    width: 43.5,
    height: 137.53
  }), /*#__PURE__*/React.createElement("rect", {
    className: "st2",
    x: 501.35,
    y: 345.16,
    width: 43.5,
    height: 30.33
  })), /*#__PURE__*/React.createElement("rect", {
    className: "st2",
    x: 501.3,
    y: 345.19,
    width: 44,
    height: 193
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M504.08,768.78v-33.8h-63.38v-33.31l40.27-146.65h66.62v144.42h11.43v35.54h-11.43v33.8h-43.5ZM478.72,699.43h25.35v-107.63l-25.35,107.63Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M577.03,758.58c-5.06-8.12-7.58-20.21-7.58-36.29v-135.47h43.75v136.09c0,5.06.78,8.62,2.36,10.69,1.57,2.07,4.02,3.11,7.33,3.11,4.47,0,7.29-1.86,8.45-5.59,1.16-3.73,1.74-9.07,1.74-16.03v-1.49l.25-126.77h43.25v181.95h-43.5v-19.39c-2.98,7.62-6.46,13.09-10.44,16.41-3.98,3.31-9.86,4.97-17.65,4.97-13.59,0-22.91-4.06-27.96-12.18Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    className: "st5",
    cx: 523.3,
    cy: 317.19,
    r: 21
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st4",
    cx: 523.3,
    cy: 306.19,
    r: 21
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st0",
    cx: 523.3,
    cy: 295.19,
    r: 21
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st3",
    cx: 523.3,
    cy: 284.19,
    r: 21
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st7",
    cx: 523.3,
    cy: 273.19,
    r: 21
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st1",
    cx: 523.3,
    cy: 262.19,
    r: 21
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st6",
    cx: 523.3,
    cy: 251.19,
    r: 21
  })))), _text || (_text = /*#__PURE__*/React.createElement("text", {
    className: "st8",
    transform: "translate(766.95 385.44)"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "TM"))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAriselogo011);
export default __webpack_public_path__ + "static/media/arise logo-01 1.6beab9b3cac7d4d9664c8a84dee01f2b.svg";
export { ForwardRef as ReactComponent };